<template>
  <div class="service">
    <Loading v-if="serviceLoading" />
    <template v-else>
      <div class="service__title">
        <div class="service__name">{{ service[`long_${language}`] }} </div>
        <div class="icon icon__delete" @click="removeService()"></div>
      </div>

      <div v-if="!dropdownModels.length"> 
        <div class="service__fields number-status-fields" v-if="
          singletonModelIndex !== null &&
          singletonFormModels[singletonModelIndex] &&
          isFirstServiceOfBranch
        ">
          <div class="service__field">
            <input type="text" class="input input--default input--shadow" placeholder="Policy Number" :value="singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].policy_number : ''
              " @input="
                $store.commit('setSpecificSingletonFormModel', {
                  index: singletonModelIndex,
                  key: 'policy_number',
                  data: $event.target.value,
                })
                " />
          </div>
          <div class="service__field">
            <VSelect :options="options" :reduce="(policy) => policy.id" label="name"
              class="select select--default select--shadow" placeholder="Status" :value="singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].policy_status_id : null
                " @input="
                  $store.commit('setSpecificSingletonFormModel', {
                    index: singletonModelIndex,
                    key: 'policy_status_id',
                    data: $event,
                  });
                " :class="{
                  'input--error':
                    singletonFormModels[singletonModelIndex] &&
                    singletonFormModels[singletonModelIndex].policy_statusHasError
                }" />
            <div class="form__error"
              v-if="singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].policy_statusHasError">
              Status is required
            </div>
          </div>
          <div class="service__field" v-if="
            singletonFormModels[singletonModelIndex] &&
            singletonFormModels[singletonModelIndex].policy_status_id == 1
          ">
            <Datepicker class="input input--default input--shadow" placeholder="Submission Date"
              :config="statics.datePickerConfig"
              :value="singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].submit_date : null"
              @input="
                $store.commit('setSpecificSingletonFormModel', {
                  index: singletonModelIndex,
                  key: 'submit_date',
                  data: $event,
                });
              $store.commit('setSpecificSingletonFormModel', {
                index: singletonModelIndex,
                key: 'submit_dateHasError',
                data: false,
              });
              "
              :class="{ 'input--error': singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].submit_dateHasError }" />
            <div class="form__error"
              v-if="singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].submit_dateHasError">
              Submission date is required
            </div>
          </div>
        </div>

        <div class="service_fields non-kvg">
          <div class="service__field">
            <Datepicker class="input input--default input--shadow" :class="{
              'input--error':
                singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].startDateHasError,
            }" placeholder="Start Date" :config="statics.datePickerConfig"
              :value="singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].startDate : null"
              @input="
                $store.commit('setSpecificSingletonFormModel', {
                  index: singletonModelIndex,
                  key: 'startDate',
                  data: $event,
                })
                " />
            <div class="form__error"
              v-if="singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].startDateHasError">
              Invalid date
            </div>
          </div>
          <template v-if="service.code != 'MM'">
            <div class="service__field">
              <Datepicker class="input input--default input--shadow" placeholder="End Date"
                :config="statics.datePickerConfig"
                :value="singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].endDate : null"
                @input="
                  $store.commit('setSpecificSingletonFormModel', {
                    index: singletonModelIndex,
                    key: 'endDate',
                    data: $event,
                  })
                  " />
            </div>
            <div class="service__field">
              <input type="text" class="input input--default input--shadow" :class="{
                'input--error':
                  singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].priceHasError,
              }" placeholder="Price" @input="
                $store.commit('setSpecificSingletonFormModel', {
                  index: singletonModelIndex,
                  key: 'price',
                  data: $event.target.value,
                })
                " />
              <div class="form__error"
                v-if="singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].priceHasError">
                Invalid price value
              </div>
            </div>
            <div class="service__field">
              <VSelect class="select select--default select--shadow" :options="intervals"
                :reduce="(interval) => interval.id" label="name" :appendToBody="true" :calculatePosition="withPopper"
                :placeholder="intervals[3].name" @input="
                  $store.commit('setSpecificSingletonFormModel', {
                    index: singletonModelIndex,
                    key: 'interval',
                    data: $event,
                  })
                  " />
            </div>
            <div class="service__field" v-if="service.id == 11">
              <input type="text" class="input input--default input--shadow"
                :placeholder="$t(`addCompanyContactModal.${'mark'}`)" @input="
                  $store.commit('setSpecificSingletonFormModel', {
                    index: singletonModelIndex,
                    key: 'plateNumber',
                    data: $event.target.value,
                  })
                  " />
            </div>
          </template>
        </div>
      </div>

      <template v-else>
        <template v-if="service.id !== KVG">
          <div class="policy__service-toggler">
            <span>Models</span>
            <div class="policy__service-adder" :class="{
              'policy__service-adder--active': showModelsDropdown,
            }" @click="showModelsDropdown = !showModelsDropdown"></div>

            <transition name="fade">
              <div class="service-dropdown" v-if="showModelsDropdown">
                <div class="service-dropdown__content">
                  <div class="service-dropdown__title">
                    Choose Models
                  </div>

                  <div class="service-dropdown__body">
                    <div v-if="!dropdownModels.length" class="service-dropdown__no-data">
                      No models found
                    </div>

                    <template v-else>
                      <div class="service-dropdown__item" v-for="model in dropdownModels" :key="model.id">
                        <div class="checkbox">
                          <input type="checkbox" class="checkbox__checkbox"
                            :checked="models.some((m) => m.id === model.id)" :id="model.id"
                            @input="addOrRemoveModels($event, model)" />

                          <label :for="model.id" class="checkbox__label checkbox__label--smaller"></label>
                        </div>
                        <label :for="model.id" class="service-dropdown__item-title">
                          {{ model.name }}
                        </label>
                      </div>
                    </template>
                  </div>

                  <div class="service-dropdown__buttons">
                    <button type="button" class="service-dropdown__button service-dropdown__button--submit"
                      @click="applyModels()"></button>
                    <button type="button" class="service-dropdown__button service-dropdown__button--cancel"
                      @click="showModelsDropdown = false"></button>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </template> 

        <template v-else>
          <div class="model"> 
            <div class="service__fields number-status-fields"
              v-if="isFirstServiceOfBranch && (service.id === KVG || (singletonModelIndex !== null && singletonFormModels[singletonModelIndex]))">

              <div class="service__field">
                <input type="text" class="input input--default input--shadow" placeholder="Policy Number"
                  :value="service.id === KVG ? singleModel.policy_number : (singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].policy_number : '')"
                  @input="
                    service.id === KVG
                      ? $store.commit('setSpecificSingleModel', { key: 'policy_number', data: $event.target.value })
                      : $store.commit('setSpecificSingletonFormModel', { index: singletonModelIndex, key: 'policy_number', data: $event.target.value })
                    " />
              </div>

              <div class="service__field">
                <VSelect :options="options" :reduce="(policy) => policy.id" label="name"
                  class="select select--default select--shadow" placeholder="Status"
                  :value="service.id === KVG ? singleModel.policy_status_id : (singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].policy_status_id : null)"
                  @input="
                    service.id === KVG
                      ? $store.commit('setSpecificSingleModel', { key: 'policy_status_id', data: $event })
                      : $store.commit('setSpecificSingletonFormModel', { index: singletonModelIndex, key: 'policy_status_id', data: $event })
                    " :class="{
                      'input--error': service.id === KVG ? singleModel.policy_statusHasError : (singletonFormModels[singletonModelIndex] && singletonFormModels[singletonModelIndex].policy_statusHasError)
                    }" />
              </div>

              <div class="service__field"
                v-if="(service.id === KVG ? singleModel.policy_status_id : (singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].policy_status_id : null)) == 1">
                <Datepicker class="input input--default input--shadow" placeholder="Submission Date"
                  :value="service.id === KVG ? singleModel.submit_date : (singletonFormModels[singletonModelIndex] ? singletonFormModels[singletonModelIndex].submit_date : null)"
                  @input="
            if (service.id === KVG) {
                    $store.commit('setSpecificSingleModel', { key: 'submit_date', data: $event });
                    $store.commit('setSpecificSingleModel', { key: 'submit_dateHasError', data: false });
                  } else {
                    $store.commit('setSpecificSingletonFormModel', { index: singletonModelIndex, key: 'submit_date', data: $event });
                    $store.commit('setSpecificSingletonFormModel', { index: singletonModelIndex, key: 'submit_dateHasError', data: false });
                  }
                    " />
              </div>
            </div>

            <div class="model__field">
              <VSelect class="select select--default select--model-dropdown select--shadow" :options="dropdownModels"
                :reduce="(model) => model.id" label="name" :appendToBody="true" :calculatePosition="withPopper"
                :value="singleModel.id" @input="
                  $store.commit('setSpecificSingleModel', {
                    key: 'id',
                    data: $event,
                  })
                  " />
            </div>
            <div class="model__fields">
              <div class="model__field">
                <Datepicker class="input input--default input--shadow"
                  :class="{ 'input--error': singleModel && singleModel.startDateHasError }" placeholder="Start Date"
                  :config="statics.datePickerConfig" :value="singleModel ? singleModel.startDate : null" @input="
                    $store.commit('setSpecificSingleModel', {
                      key: 'startDate',
                      data: $event,
                    })
                    " />
                <div class="form__error" v-if="singleModel && singleModel.startDateHasError">
                  Invalid date
                </div>
              </div>
              <div class="model__field">
                <Datepicker class="input input--default input--shadow" placeholder="End Date"
                  :config="statics.datePickerConfig" :value="singleModel ? singleModel.endDate : null" @input="
                    $store.commit('setSpecificSingleModel', {
                      key: 'endDate',
                      data: $event,
                    })
                    " />
              </div>
              <div class="model__field">
                <VSelect class="select select--default select--shadow" :options="dropdownFranchises"
                  :reduce="(franchise) => franchise.id" label="franchise" :appendToBody="true"
                  :calculatePosition="withPopper" placeholder="Franchise" @input="
                    $store.commit('setSpecificSingleModel', {
                      key: 'franchise',
                      data: $event,
                    })
                    " />
              </div>
              <div class="model__field">
                <VSelect class="select select--default select--shadow" :options="accidents"
                  :reduce="(accident) => accident.value" label="title" :appendToBody="true"
                  :calculatePosition="withPopper" placeholder="Accident" @input="
                    $store.commit('setSpecificSingleModel', {
                      key: 'accident',
                      data: $event,
                    })
                    " />
              </div>
              <div class="model__field">
                <input type="text" class="input input--default input--shadow" placeholder="Doctor name" @input="
                  $store.commit('setSpecificSingleModel', {
                    key: 'doctorName',
                    data: $event.target.value,
                  })
                  " />
              </div>
              <div class="model__field">
                <input type="text" class="input input--default input--shadow"
                  :class="{ 'input--error': singleModel.priceHasError }" placeholder="Price" @input="
                    $store.commit('setSpecificSingleModel', {
                      key: 'price',
                      data: $event.target.value,
                    })
                    " />
                <div class="form__error" v-if="singleModel.priceHasError">
                  Invalid price value
                </div>
              </div>
              <div class="model__field">
                <VSelect class="select select--default select--shadow" :options="intervals"
                  :reduce="(interval) => interval.id" label="name" :appendToBody="true" :calculatePosition="withPopper"
                  :placeholder="intervals[3].name" @input="
                    $store.commit('setSpecificSingleModel', {
                      key: 'interval',
                      data: $event,
                    })
                    " />
              </div>
            </div>
          </div>
        </template>

        <div class="models">
          <div class="model model--multiple" v-for="(model, index) in models" :key="model.id">
            <div class="model__name">{{ model.name }}</div>
            <div class="service__fields number-status-fields" v-if="isFirstServiceOfBranch"> 
              <div class="service__field">
                <input type="text" class="input input--default input--shadow" placeholder="Policy Number"
                  :value="formModels[index] ? formModels[index].policy_number : ''" @input="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'policy_number',
                      data: $event.target.value,
                    })
                    " />
              </div>
              <div class="service__field">
                <VSelect :options="options" :reduce="(policy) => policy.id" label="name"
                  class="select select--default select--shadow" placeholder="Status"
                  :value="formModels[index] ? formModels[index].policy_status_id : null" @input="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'policy_status_id',
                      data: $event,
                    });
                  " :class="{ 'input--error': formModels[index] && formModels[index].policy_statusHasError }" />
                <div class="form__error" v-if="formModels[index] && formModels[index].policy_statusHasError">
                  Status is required
                </div>
              </div>
              <div class="service__field" v-if="formModels[index] && formModels[index].policy_status_id == 1">
                <Datepicker class="input input--default input--shadow" placeholder="Submission Date"
                  :config="statics.datePickerConfig" :value="formModels[index] ? formModels[index].submit_date : null"
                  @input="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'submit_date',
                      data: $event,
                    });
                  $store.commit('setSpecificFormModel', {
                    index,
                    key: 'submit_dateHasError',
                    data: false,
                  });
                  " :class="{ 'input--error': formModels[index] && formModels[index].submit_dateHasError }" />
                <div class="form__error" v-if="formModels[index] && formModels[index].submit_dateHasError">
                  Submission date is required
                </div>
              </div>
            </div>

            <div class="model__fields">
              <div class="model__field">
                <Datepicker class="input input--default input--shadow" :class="{
                  'input--error': formModels[index] && formModels[index].startDateHasError,
                }" placeholder="Start Date" :config="statics.datePickerConfig"
                  :value="formModels[index] ? formModels[index].startDate : null" @input="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'startDate',
                      data: $event,
                    })
                    " />
                <div class="form__error" v-if="formModels[index] && formModels[index].startDateHasError">
                  Invalid date
                </div>
              </div>
              <div class="model__field">
                <Datepicker class="input input--default input--shadow" placeholder="End Date"
                  :config="statics.datePickerConfig" :value="formModels[index] ? formModels[index].endDate : null"
                  @input="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'endDate',
                      data: $event,
                    })
                    " />
              </div>
              <div class="model__field">
                <input type="text" class="input input--default input--shadow"
                  :class="{ 'input--error': formModels[index] && formModels[index].priceHasError }" placeholder="Price"
                  @input="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'price',
                      data: $event.target.value,
                    })
                    " />
                <div class="form__error" v-if="formModels[index] && formModels[index].priceHasError">
                  Invalid price value
                </div>
              </div>
              <div class="model__field">
                <VSelect class="select select--default select--shadow" :options="intervals"
                  :reduce="(interval) => interval.id" label="name" :appendToBody="true" :calculatePosition="withPopper"
                  :placeholder="intervals[3].name" @input="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'interval',
                      data: $event,
                    })
                    " />
              </div>
              <div class="model__field model__field--economy"
                v-if="model && model.model_categories && model.model_categories.length">
                <VSelect class="select select--default select--shadow" :options="model.model_categories"
                  :reduce="(category) => category.id" label="name" :appendToBody="true" :calculatePosition="withPopper"
                  placeholder="Economy" @input="
                    $store.commit('setSpecificFormModel', {
                      index,
                      key: 'economy',
                      data: $event,
                    })
                    " />
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import statics from "@/statics";
import Loading from "@/partials/Loading";
import { parseBirthday } from "@/helpers/entityParsers";
import { formatDisplayDate, formatDate } from "@/helpers/dateFormatters";
import withPopper from "@/helpers/withPopper";

export default {
  name: "Service",

  components: {
    Loading,
  },

  props: {
    service: {
      required: true,
      type: Object,
    },

    companyId: {
      required: true,
      type: Number,
    },

    deleteService: {
      required: true,
      type: Function,
    },

    servicesToDelete: {
      required: true,
      type: Array,
    },

    options: {
      required: false,
      type: Array,
    },
  },

  data() {
    return {
      formatDisplayDate,
      statics,
      KVG: statics.KVG,
      maxUnderAgedIdFranchise: 7,
      teenage: 18,
      serviceLoading: false,
      showModelsDropdown: false,
      dropdownModels: [],
      preModels: [],
      models: [],
      singletonModelIndex: null,
      withPopper,
    };
  },

  watch: {
    servicesToDelete(services) {
      if (services.length) {
        const serviceToDelete = services.find(
          (service) => service.id === this.service.id
        );
        if (serviceToDelete) {
          const serviceExists = this.servicesToRemove.some(
            (service) => service.id === serviceToDelete.id
          );
          if (!serviceExists) {
            const { id } = serviceToDelete;
            if (id === this.KVG) {
              this.$store.commit("setServicesToRemove", [
                ...this.servicesToRemove,
                { id, type: "KVG" },
              ]);
            } else if (this.dropdownModels.length) {
              this.$store.commit("setServicesToRemove", [
                ...this.servicesToRemove,
                { id, type: "multiple" },
              ]);
            } else {
              this.$store.commit("setServicesToRemove", [
                ...this.servicesToRemove,
                { id, type: "singleton" },
              ]);
            }
          }
        }
      }
    },
  },

  computed: {
    ...mapGetters([
      "policyForms",
      "customerDetails",
      "formModels",
      "singleModel",
      "singletonFormModels",
      "servicesToRemove",
      "language",
    ]),
    isFirstServiceOfBranch() {
      const allModels = [];

      // KVG models (treat all preModels as KVG models)
      if (this.service.id === this.KVG && this.preModels.length) {
        this.preModels.forEach((model) => allModels.push({ ...model, type: "KVG" }));
      } else if (this.singleModel && this.singleModel.serviceId) {
        allModels.push({ ...this.singleModel, type: "KVG" });
      }

      // Singleton and multiple models
      this.singletonFormModels.forEach((m, i) =>
        allModels.push({ ...m, type: "singleton", index: i })
      );
      this.formModels.forEach((m) => allModels.push({ ...m, type: "multiple" }));

      const firstModel = allModels.find(
        (m) => m.branch_category_id === this.service.branch_category_id
      );

      if (!firstModel) return false;

      switch (firstModel.type) {
        case "KVG":
          return (
            this.service.id === this.KVG &&
            (this.singleModel.id === firstModel.id ||
              this.models.some((m) => m.id === firstModel.id) ||
              this.preModels.some((m) => m.id === firstModel.id))
          );

        case "singleton":
          return firstModel.index === this.singletonModelIndex;

        case "multiple":
          return Array.isArray(this.models) &&
            this.models.some((model) => model.id === firstModel.id);

        default:
          return false;
      }
    },

    intervals() {
      return this.policyForms.intervals;
    },

    accidents() {
      return [
        { title: "Yes", value: true },
        { title: "No", value: false },
      ];
    },

    franchises() {
      return this.policyForms.franchises;
    },

    dropdownFranchises() {
      return parseBirthday(this.customerDetails.birthday) <= this.teenage
        ? this.underAgedFranchises
        : this.agedFranchises;
    },

    underAgedFranchises() {
      return this.franchises.filter(
        (franchise) => franchise.id <= this.maxUnderAgedIdFranchise
      );
    },

    agedFranchises() {
      return this.franchises.filter(
        (franchise) => franchise.id > this.maxUnderAgedIdFranchise
      );
    },
  },
  async created() {
    this.serviceLoading = true;

    this.dropdownModels = await this.$store.dispatch(
      "getModelsByCompanyServiceAndCustomer",
      {
        serviceId: this.service.id,
        companyId: this.companyId,
        customerId: this.customerDetails.id,
      }
    );

    const isKVG = this.service.id === this.KVG;
    const hasNoModels = this.dropdownModels.length === 0;

    if (isKVG && !hasNoModels) {
      const modelId = this.dropdownModels[0].id;
      this.$store.commit("setSingleModel", {
        ...this.singleModel,
        id: modelId,
        serviceId: this.service.id,
        branch_category_id: this.service.branch_category_id,
        policy_statusHasError: false,
      });
    } else if (hasNoModels) {
      const newSingleton = {
        serviceId: this.service.id,
        branch_category_id: this.service.branch_category_id,
        policy_number: "",
        policy_status_id: "",
        policy_statusHasError: false,
        submit_date: null,
        submit_dateHasError: false,
        startDate: "",
        endDate: formatDate(statics.lastDateOfCurrentYear),
        price: "",
        startDateHasError: false,
        priceHasError: false,
      };

      const existingIdx = this.singletonFormModels.findIndex(m => m.serviceId === this.service.id);
      if (existingIdx === -1) {
        this.$store.commit("setSingletonFormModels", [...this.singletonFormModels, newSingleton]);
      }

      if (isKVG) {
        this.$store.commit("setSingleModel", { id: "", serviceId: "" });
      }
    }

    const finalIndex = this.singletonFormModels.findIndex(
      (model) => model.serviceId === this.service.id
    );
    this.singletonModelIndex = finalIndex !== -1 ? finalIndex : null;

    this.serviceLoading = false;
  },

  methods: {
    addOrRemoveModels(event, model) {
      const { checked } = event.target;
      const existingModel = this.preModels.findIndex((m) => m.id === model.id);

      if (checked && existingModel === -1) {
        this.preModels = [...this.preModels, model];

        if (!this.formModels.some((m) => m.id === model.id)) {
          // FIND THE CURRENT VALUES FROM THE BRANCH MASTER
          // We check singleModel (KVG) OR other models in the same branch
          const master = [this.singleModel, ...this.formModels, ...this.singletonFormModels].find(
            m => m && m.branch_category_id === this.service.branch_category_id && m.policy_status_id
          );

          this.$store.commit("setFormModels", [
            ...this.formModels,
            {
              id: model.id,
              serviceId: this.service.id,
              branch_category_id: this.service.branch_category_id,
              // INHERIT OR DEFAULT
              policy_number: master ? master.policy_number : "",
              policy_status_id: master ? master.policy_status_id : "",
              submit_date: master ? master.submit_date : null,
              policy_statusHasError: false,
              submit_dateHasError: false,
              startDate: "",
              endDate: formatDate(statics.lastDateOfCurrentYear),
              startDateHasError: false,
              priceHasError: false,
            },
          ]);
        }
      } else {
        this.preModels.splice(existingModel, 1);
      }
    },

    applyModels() {
      this.models = [...this.preModels];
      const formModelIds = this.models.map((m) => m.id);

      const newFormModels = this.formModels.filter((m) =>
        formModelIds.includes(m.id)
      );

      this.$store.commit("setFormModels", newFormModels);
      this.showModelsDropdown = false;
    },

    removeService() {
      if (this.service.id === this.KVG) {
        this.$store.commit("setSingleModel", {
          ...this.singleModel,
          id: "",
          serviceId: "",
          startDate: "",
          franchise: "",
          accident: "",
          doctorName: "",
          price: "",
          interval: "",
          startDateHasError: false,
          priceHasError: false,
        });
      } else if (!this.dropdownModels.length) {
        const singletonModels = [...this.singletonFormModels];
        singletonModels.splice(this.singletonModelIndex, 1);
        this.$store.commit("setSingletonFormModels", singletonModels);
      } else {
        this.$store.commit("setFormModels", []);
      }
      this.deleteService(this.service.id);
    },
  },
};
</script>

<style scoped lang="scss">
.non-kvg {
  display: flex;

  .service__field {
    flex: 1;
  }
}

.service,
.model {
  position: relative;
  min-height: 80px;

  &--multiple {
    padding: 20px 50px;
    border-bottom: 1px solid var(--border-10);

    .model__name {
      color: var(--text-2);
      font-family: var(--muli-text-semi-bold);
      font-size: var(--x-small);
      margin-bottom: 15px;
    }
  }

  &__title {
    display: flex;
    align-items: center;
    margin: 20px 0;
  }

  &__name {
    font-size: var(--x-small);
    color: var(--text-5);
    margin-right: 15px;
  }

  &__fields {
    display: flex;
  }

  &__field {
    width: 110px;
    margin-right: 5px;
    position: relative;

    &--economy {
      width: 180px;
    }
  }

  .policy__service-toggler {
    margin: 0;
  }
}

.models {
  border-top: 1px solid var(--border-10);
  margin-top: 15px;
}

.select--model-dropdown {
  width: 280px !important;
  margin-bottom: 20px;
}

.number-status-fields {
  margin-bottom: 20px;
  justify-content: space-between;
  //flex-wrap: wrap;
  gap: 20px;

  .service__field {
    // width: 45%;
    flex: 1;
  }
}
</style>
